import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { lineItemStatuses } from '@/parcels/constants'
import parcelServices from '@/parcels/services/services'
import routes from '@/Router/routes.constants'

import { getAmendItemsPayload } from './helpers'

const useAmendParcelItems = ({ storeId, parcelId, relatedId, items, navigation }) => {
  const { fetchData, loading } = useFetch(parcelServices.amendParcelItems, { doInitialRequest: false })
  const [showAmendItemsErrorModal, setShowAmendItemsErrorModal] = useState(false)

  const amendItems = async () => {
    const payload = getAmendItemsPayload(items)

    try {
      await fetchData({ storeId, relatedId, payload })
      navigation(routes.parcelDetailPage.replace(':id', parcelId))
    } catch {
      setShowAmendItemsErrorModal(true)
    }
  }

  const hasSomeItemsToAmend = items?.some(
    item => item.newStatus === lineItemStatuses.packed && item.status !== lineItemStatuses.packed
  )

  const closeAmendItemsErrorModal = () => {
    setShowAmendItemsErrorModal(false)
  }

  return {
    amendItems,
    amendingItems: loading,
    showAmendItemsErrorModal,
    hasSomeItemsToAmend,
    closeAmendItemsErrorModal,
  }
}

export default useAmendParcelItems
